(ns teamoesterreich.admin-mode.modal.toe-info
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [goog.date.DateTime]
            [reagent-material-ui.icons.call :refer [call]]
            [reagent-material-ui.icons.alternate-email :refer [alternate-email]]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [reagent.core :as r]))


(defn get-user-details [!actual-user tomId]
  (s-user/get-user-details tomId (fn [data] (reset! !actual-user data)))
  )

(defn get-modal [!tomId]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId]
        (js/console.log "render toe info " tomId user (:reqTomId user))
        (when (and @!tomId (not= @!tomId (:reqTomId user))) (get-user-details !actual-user tomId))
        [mui/modal
         {:aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (not (nil? @!tomId))
          :onClose          (fn []
                              (reset! !actual-user {})
                              (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] nil))
          }
         (if (or (not= @!tomId (:reqTomId user)) (:error user))
           ;no data
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str (txt/transl "Personalnummer:") " " tomId)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] nil)
              }
             "Schließen"]
            ]
           ;has data
           [:div
            {
             :class "modal"
             :style {:width 400}}
            [:h4 (txt/transl "Personalnummer:") " "
             (if (d-rights/allow-admin-for d-rights/USER)
               [:a {:href (str "/#user-view$" tomId) :target "_blank"} (str tomId )]
               tomId)
             ]
            [mui/text-field {:readOnly  true
                             :fullWidth true
                             :value     (:firstName user)
                             :variant   "outlined"
                             :label     "Vorname"}]
            [:br]
            [:br]
            [mui/text-field {:readOnly  true
                             :fullWidth true
                             :value     (:lastName user)
                             :variant   "outlined"
                             :label     "Nachname"}]
            [:br]
            [:br]
            [mui/text-field {:readOnly  true
                             :fullWidth true
                             :variant   "outlined"
                             :value     (str (:zip user) " " (:city user) ", " (:street user) " " (:streetNo user))
                             :label     "Adresse"}]
            [:br]
            [:br]
            [mui/text-field {:readOnly   true
                             :fullWidth  true
                             :InputProps {:startAdornment
                                          (r/as-element [mui/input-adornment
                                                         {:position "start"}
                                                         [:a
                                                          {:href  (str "phone:" (:phoneNumber user))
                                                           :title (str "Starte Anruf: " (:phoneNumber user))}
                                                          [call]]])}
                             :variant    "outlined"
                             :value      (str (:phoneNumber user))
                             :label      "Telefonnummer"}]
            [:br]
            [:br]

            [mui/text-field {:readOnly   true
                             :fullWidth  true
                             ; :disabled true
                             :InputProps {:startAdornment
                                          (r/as-element [mui/input-adornment
                                                         {:position "start"}
                                                         [:a
                                                          {:href  (str "mailto:" (:email user))
                                                           :title (str "Sende Email an: " (:email user))}
                                                          [alternate-email]]])}
                             :variant    "outlined"
                             :value      (str (:email user))
                             :label      "Email"}]

            [:br]
            [:br]
            [mui/button
             {:variant "contained"
              :onClick #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] nil)
              }
             "Schließen"]
            (when (d-rights/allow-admin-for d-rights/USER)
              [mui/button
               {:color   "primary"
                :variant "contained"
                :style   {:float "right"}
                :onClick (fn []
                           (a/open-user-view tomId)
                           (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] nil)
                           )
                }
               "Details öffnen"])
            ]
           )]
        ))))

